// Function to handle radio change
function handleRadioChange() {
  if (this.checked) {
    const selectedVariant = this.value;

    // Find the closest .hidden element and extract the text from it and sort it into a key value pair
    // The .hidden element contains the metafield data 
      const hiddenElement = this.closest('.product-variants.product-variants--radio').querySelector('.hidden');
      const text = hiddenElement.textContent;
      const regex = /"([^"]+)": "([^"]+)"/g;
      let match;
      const obj = new Map();
      while ((match = regex.exec(text)) !== null) {
        const key = match[1];
        const value = match[2];
        obj.set(key, value);
      }

    // Find the key in the Map where the key starts with the output of the function
    for (let [key, value] of obj) {
      if (key.startsWith(selectedVariant)) {
        // Find the closest parent .product-variants.product-variants--radio and then find the .variant-description-short within it
        const variantDescription = this.closest('.product-variants.product-variants--radio').querySelector('.variant-description-short');
        variantDescription.textContent = value;
        break;
      }
    }
  }
}

// Function to attach event listeners to radio buttons
function attachEventListeners() {
  const variantRadios = document.querySelectorAll('[type="radio"]');
  variantRadios.forEach(function(radio) {
    radio.addEventListener('change', handleRadioChange);
  });
}

document.addEventListener('DOMContentLoaded', attachEventListeners);

// This watches for the quick buy modal and attaches listeners if it is opened on any page in the theme
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (document.querySelector('.product-quick-view-body')) {
      attachEventListeners();
    }
  });
});

observer.observe(document, {childList: true, subtree: true });
